module.exports = __webpack_public_path__ + "static/img/5.ae9c7fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/eng/5.png
// module id = Dyso
// module chunks = 0